module.exports = __webpack_public_path__ + "img/pt.08976721.png";